import { Component, OnInit, signal, computed } from '@angular/core';
import { BaseComponent } from '../../../../core/abstracts/baseComponent';
import { DateRangeModel } from '../../../../models/dateRangeModel';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { State } from '../../../../core/store';
import { DropdownFilterService } from '../../../../core/services/dropdown-filter.service';
import { PagingResultsModel } from '../../../../models/pagingResultsModel';
import { RecurringHolidayModel } from '../../../../models/holidayModel';
import { MonthModel } from '../../../../models/monthModel';
import { getRecurringHolidayList, saveRecurringHolidaySuccess, showEditRecurringHoliday } from '../../../../core/store/holiday/holiday.actions';
import { tap } from 'rxjs';
import { ModifiedSelectItem } from '../../../../models/utilModels';
import { getOptoLinkFromUrl } from '../../../../helpers/utils';

@Component({
    selector: 'app-recurring-holiday',
    templateUrl: './recurring-holiday.component.html',
    styleUrls: ['./recurring-holiday.component.scss'],
    standalone: false
})
export class RecurringHolidayComponent extends BaseComponent implements OnInit {
  holidays: PagingResultsModel<RecurringHolidayModel>;
  filter: any;

  loadingHolidayList: boolean = true;
  canEdit: boolean = false;
  canViewMassCancellations: boolean = false;

  holidayName: string = "";

  monthList: MonthModel[];
  month: number = -1;

  dateRangeList: DateRangeModel[];
  dateRange: DateRangeModel;
  startDate: string = null;
  endDate: string = null;
  isCustomDateRange: boolean = false;

  showArchived: boolean = false;

  totalRecords = signal<number>(0);
  dropdownOptions = computed(() => {
    var total = this.totalRecords();
    return [
      { label: '20', value: 20 },
      { label: '50', value: 50 },
      { label: '100', value: 100 },
      { label: '200', value: 200 },
      { label: '500', value: 500 },
      { label: 'All', value: total > 0 ? total : 20 } 
    ];
  });
  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private dropdownFilterService: DropdownFilterService) {
    super();
  }

  ngOnInit() {
    this.subs.push(
      this.store.select(s => s.holidayState.loadingRecurringHolidayList).subscribe(loadingHolidayList => {
        this.loadingHolidayList = loadingHolidayList;
      }),
      this.store.select(s => s.accountState.user?.permissionIDs).subscribe(permissionIDs => {
        this.canEdit = permissionIDs && !!permissionIDs.find(p => p === 3037);
        this.canViewMassCancellations = permissionIDs && !!permissionIDs.find(p => p === 3226 || p === 3227);
      }),            
      this.store.select(s => s.holidayState.recurringHolidayList).subscribe(holidayList => {
        this.holidays = holidayList;
        if(holidayList != null)
     	  	this.totalRecords.set(holidayList.totalRecords);
      }),
      this.actions$.pipe(
        ofType(saveRecurringHolidaySuccess),
        tap(action => {
          this.reloadHolidays(this.filter);
        })
      ).subscribe(),
    );

    this.monthList = this.dropdownFilterService.getMonthsWithAll();
    if (this.monthList && this.monthList.length > 0) {
      this.month = this.monthList[0].value;
    }
    this.dateRangeList = this.dropdownFilterService.get30DayDateRanges();
    if (this.dateRangeList && this.dateRangeList.length > 0) {
      this.dateRange = this.dateRangeList[0];
    }
  }

  changedDateRange() {
    if (this.dateRange.isCustom) {
      this.isCustomDateRange = true;
      return; //reload after manually changing date
    }

    this.isCustomDateRange = false;
    this.startDate = this.dateRange.startDate;
    this.endDate = this.dateRange.endDate;
    this.reloadHolidays(this.filter);
  }

  reloadHolidays(event) {
    this.filter = event;
    this.store.dispatch(getRecurringHolidayList({
      filter: this.filter,
      holidayName: this.holidayName,      
      month: this.month,      
      startDate: this.startDate,
      endDate: this.endDate,
      showArchived: this.showArchived
    }));
  }

  editHoliday(holiday) {
    this.store.dispatch(showEditRecurringHoliday({ holiday: holiday }));
  }

  goToMassCancellationsUrl() {
    window.location.href = getOptoLinkFromUrl() + "/Scheduling/Cancellation/MassCancellations";
  }
}
